import { isFeatureEnabled } from 'owa-feature-flags';
import { InlineImageLoadEventName } from '../datapoints';
import { PerformanceDatapoint } from 'owa-analytics';

/**
 * Start an image load performance data point
 */
export default function startImageLoadPerfDataPoint(): PerformanceDatapoint {
    // Task 59383: Enable isQos for InlineImageLoad so that it can be passive monitored
    // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/59383
    // Enable isQos so that we can have passive monitor for it
    // InlineImageLoad is also a big data point so to keep it still at 5% sampling at WW, 100% sampling for SDF
    return new PerformanceDatapoint(InlineImageLoadEventName, {
        logEvery: isFeatureEnabled('ring-dogfood') ? 1 : 20,
    });
}
